import { PALETTES } from '@core/constants/palettes';
import type { ColorMaps } from '../../../../../../../core/models/user';

export const contrastPalettes: Array<ColorMaps> = [
  {
    name: 'SMS',
    clip: { max: 1, min: 0 },
    colors: [
      {
        color: '#FD281B',
        start: 0.0,
        end: 0.027,
        rate: 0,
      },
      {
        color: '#FD411D',
        start: 0.027,
        end: 0.0541,
        rate: 0,
      },
      {
        color: '#FD7121',
        start: 0.0541,
        end: 0.0811,
        rate: 0,
      },
      {
        color: '#FCAB28',
        start: 0.0811,
        end: 0.1081,
        rate: 0,
      },
      {
        color: '#FCE630',
        start: 0.1081,
        end: 0.1351,
        rate: 0,
      },
      {
        color: '#FCF132',
        start: 0.1351,
        end: 0.1892,
        rate: 0,
      },
      {
        color: '#FBF733',
        start: 0.1892,
        end: 0.2162,
        rate: 0,
      },
      {
        color: '#FBFC34',
        start: 0.2162,
        end: 0.2432,
        rate: 0,
      },
      {
        color: '#E3FF33',
        start: 0.2432,
        end: 0.2703,
        rate: 0,
      },
      {
        color: '#CCFF32',
        start: 0.2703,
        end: 0.2973,
        rate: 0,
      },
      {
        color: '#B4FE30',
        start: 0.2973,
        end: 0.3243,
        rate: 0,
      },
      {
        color: '#9EFE2F',
        start: 0.3243,
        end: 0.3514,
        rate: 0,
      },
      {
        color: '#87FD2F',
        start: 0.3514,
        end: 0.3784,
        rate: 0,
      },
      {
        color: '#71FD2E',
        start: 0.3784,
        end: 0.4054,
        rate: 0,
      },
      {
        color: '#47FD2D',
        start: 0.4054,
        end: 0.4324,
        rate: 0,
      },
      {
        color: '#1DFC2C',
        start: 0.4324,
        end: 0.4595,
        rate: 0,
      },
      {
        color: '#00FC2C',
        start: 0.4595,
        end: 0.5135,
        rate: 0,
      },
      {
        color: '#00FC3D',
        start: 0.5135,
        end: 0.5405,
        rate: 0,
      },
      {
        color: '#00FC4C',
        start: 0.5405,
        end: 0.5676,
        rate: 0,
      },
      {
        color: '#00FC5F',
        start: 0.5676,
        end: 0.5946,
        rate: 0,
      },
      {
        color: '#00FC73',
        start: 0.5946,
        end: 0.6216,
        rate: 0,
      },
      {
        color: '#00FC8A',
        start: 0.6216,
        end: 0.6486,
        rate: 0,
      },
      {
        color: '#00FCA1',
        start: 0.6486,
        end: 0.6757,
        rate: 0,
      },
      {
        color: '#0EFCB9',
        start: 0.6757,
        end: 0.7027,
        rate: 0,
      },
      {
        color: '#16FCD3',
        start: 0.7027,
        end: 0.7297,
        rate: 0,
      },
      {
        color: '#1CFCED',
        start: 0.7297,
        end: 0.7568,
        rate: 12,
      },
      {
        color: '#20FCFD',
        start: 0.7568,
        end: 0.7838,
        rate: 14,
      },
      {
        color: '#22DDFC',
        start: 0.7838,
        end: 0.8108,
        rate: 16,
      },
      {
        color: '#24BFFC',
        start: 0.8108,
        end: 0.8378,
        rate: 18,
      },
      {
        color: '#25A2FB',
        start: 0.8378,
        end: 0.8649,
        rate: 20,
      },
      {
        color: '#2785FA',
        start: 0.8649,
        end: 0.8919,
        rate: 0,
      },
      {
        color: '#286AFA',
        start: 0.8919,
        end: 0.9189,
        rate: 0,
      },
      {
        color: '#284FFA',
        start: 0.9189,
        end: 0.9459,
        rate: 0,
      },
      {
        color: '#2936F9',
        start: 0.9459,
        end: 0.973,
        rate: 0,
      },
      {
        color: '#291DF9',
        start: 0.973,
        end: 1.0,
        rate: 0,
      },
    ],
  },
  {
    name: 'SMS 11',
    clip: { ...PALETTES[0].clip },
    colors: [...PALETTES[0].colors],
  },
] as const;
